module.exports = __webpack_public_path__ + "static/media/D_J.3e98732c.png";